import * as React from "react";
import type { SVGProps } from "react";
const SvgGiftIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    className="gift_icon_svg__icon"
    viewBox="0 0 1024 1024"
    {...props}
  >
    <path
      fill="currentColor"
      d="M514.603 171.435C546.432 113.579 605.61 42.667 704 42.667A149.333 149.333 0 0 1 838.912 256h99.755a42.667 42.667 0 0 1 42.666 42.667V512a42.667 42.667 0 0 1-42.666 42.667H896v384a42.667 42.667 0 0 1-42.667 42.666H170.667A42.667 42.667 0 0 1 128 938.667v-384H85.333A42.667 42.667 0 0 1 42.667 512V298.667A42.667 42.667 0 0 1 85.333 256h99.755A149.333 149.333 0 0 1 320 42.667c98.39 0 157.568 70.912 189.397 128.768l2.603 4.821 2.603-4.821zm-45.27 169.898H128v128h341.333v-128zM454.571 256a350.208 350.208 0 0 0-19.968-43.435C407.765 163.755 370.944 128 320 128a64 64 0 0 0 0 128h134.57zm294.698-18.773A64 64 0 0 0 704 128c-50.944 0-87.765 35.755-114.603 84.565A350.208 350.208 0 0 0 569.43 256H704a64 64 0 0 0 45.227-18.773zM554.667 469.333H896v-128H554.667v128zm0 426.667h256V554.667h-256V896zm-85.334-341.333h-256V896h256V554.667z"
    />
  </svg>
);
export default SvgGiftIcon;
